const gallerySelector = "[data-product-gallery]"
const itemSelector = "[data-product-gallery-item]"
const tabSelector = "button[data-product-gallery-tab]"

const reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches

const trackStickyHeader = (gallery) => {
  const header = document.querySelector(".storefront-header")
  if (!header) return

  let frame
  const update = () => {
    const headerBottom = Math.max(header.getBoundingClientRect().bottom, 0)
    gallery.style.setProperty("--product-gallery-top", `${headerBottom}px`)
    frame = undefined
  }
  const scheduleUpdate = () => {
    if (!frame) frame = window.requestAnimationFrame(update)
  }

  window.addEventListener("scroll", scheduleUpdate, { capture: true, passive: true })
  window.addEventListener("resize", scheduleUpdate, { passive: true })
  update()
}

const updateVideo = (item, active) => {
  const video = item.querySelector("[data-product-gallery-video]")
  if (!video) return

  if (active && !reducedMotion()) {
    video.play().catch(() => {})
  } else {
    video.pause()
  }
}

const activate = (gallery, index, focusTab = false) => {
  const items = [...gallery.querySelectorAll(itemSelector)]
  const tabs = [...gallery.querySelectorAll(tabSelector)]

  items.forEach((item, itemIndex) => {
    const active = itemIndex === index
    item.hidden = !active
    updateVideo(item, active)
  })

  tabs.forEach((tab, tabIndex) => {
    const active = tabIndex === index
    tab.setAttribute("aria-selected", active ? "true" : "false")
    tab.tabIndex = active ? 0 : -1
  })

  gallery.dataset.productGalleryActive = String(index)
  if (focusTab) tabs[index]?.focus()
}

export const initProductGallery = () => {
  document.querySelectorAll(gallerySelector).forEach((gallery) => {
    if (gallery.dataset.productGalleryReady === "true") return
    gallery.dataset.productGalleryReady = "true"
    trackStickyHeader(gallery)

    const tabs = [...gallery.querySelectorAll(tabSelector)]

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => activate(gallery, index))
      tab.addEventListener("keydown", (event) => {
        let nextIndex

        if (event.key === "ArrowRight") nextIndex = (index + 1) % tabs.length
        if (event.key === "ArrowLeft") nextIndex = (index - 1 + tabs.length) % tabs.length
        if (event.key === "Home") nextIndex = 0
        if (event.key === "End") nextIndex = tabs.length - 1
        if (nextIndex === undefined) return

        event.preventDefault()
        activate(gallery, nextIndex, true)
      })
    })

    const firstVideo = gallery.querySelector("[data-product-gallery-video]")
    if (firstVideo && reducedMotion()) {
      firstVideo.removeAttribute("autoplay")
      firstVideo.pause()
    }

    activate(gallery, 0)
  })
}
